

export const revokePreviewUrl = (url: string) => {
  if (url && url !== "document" && url !== "error") {
    URL.revokeObjectURL(url);
  }
};

export const cleanupUrls = (previews: { url: string }[]) => {
  previews.forEach(p => revokePreviewUrl(p.url));
};